import React from 'react';

interface SectionNumberBadgeProps {
  number: string;
  inverse?: boolean;
}

const SectionNumberBadge: React.FC<SectionNumberBadgeProps> = ({ number, inverse = false }) => (
  <span
    aria-hidden="true"
    style={{
      display: 'inline-block',
      minWidth: 26,
      marginRight: 8,
      fontSize: 12,
      fontWeight: 700,
      letterSpacing: '0.03em',
      color: inverse ? 'rgba(255,255,255,0.75)' : 'var(--ec-primary, #0EA5A4)',
    }}
  >
    {number}
  </span>
);

export default SectionNumberBadge;
